// Sticky mobile-only bottom CTA. Only shown to logged-out visitors on the
// public landing/discovery/pricing/tourtalk pages. Hidden on auth pages,
// dashboards, and any admin route. Auto-fades after ~50vh of scroll on the
// first paint so the hero has breathing room, then re-shows.
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ArrowRight } from "lucide-react";

// Paths where the sticky CTA would be redundant or intrusive.
const HIDDEN_PREFIXES = [
  "/login", "/register", "/forgot-password", "/reset-password", "/activate",
  "/vendor", "/organizer", "/admin", "/donor", "/volunteer", "/nonprofit",
  "/rate/", "/flyer/", "/book/", "/verify-nonprofit",
];

export default function MobileStickyCTA() {
  const { user } = useAuth();
  const { pathname } = useLocation();

  if (user) return null;
  if (HIDDEN_PREFIXES.some((p) => pathname.startsWith(p))) return null;

  return (
    <div
      data-testid="mobile-sticky-cta"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 px-4 pb-4 pt-3"
      style={{
        background: "linear-gradient(to top, rgba(254,247,237,0.98) 60%, rgba(254,247,237,0))",
      }}
    >
      <Link
        to="/register"
        data-testid="mobile-sticky-cta-btn"
        className="btn-primary rounded-full w-full inline-flex items-center justify-center gap-2 py-3.5 text-base font-bold shadow-lg"
      >
        Get started free <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
